import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { MobileAccordion } from './MobileAccordion.js';
import { i18n } from '../../i18n/translate.js';
import { WindowHelperWrapper } from '../../utils/WindowHelper.js';
import { Table as Table$1 } from './Table.js';
import { Table } from '../../core/components/Table/component.js';
import { Actions } from '../Controls/Actions/component.js';
var RESPONSIVE_DATA_BREAKPOINT = 768;
/** renders data either as a MobileAccordion or Table component depending on
 *  the size of the browser window */

var ResponsiveDataList = /*#__PURE__*/function (_React$Component) {
  function ResponsiveDataList(props) {
    var _this;

    _classCallCheck(this, ResponsiveDataList);

    _this = _callSuper(this, ResponsiveDataList, [props]);

    _defineProperty(_this, "onBreakpointChange", function (index) {
      _this.setState({
        isMobile: !index
      });
    });
    /** calling this method to triggers a highlight animation on the row whose
     *  keyField matches the provided value */


    _defineProperty(_this, "highlightRow", function (value) {
      if (_this.table) {
        _this.table.highlightRow(value);
      }
    });

    _defineProperty(_this, "setColumns", function () {
      var _this$props = _this.props,
          actions = _this$props.actions,
          dropdownActions = _this$props.dropdownActions,
          keyField = _this$props.keyField,
          data = _this$props.data;
      var fields = _this.props.columns || _this.props.fields;

      if (!fields) {
        return null;
      }

      var columns = fields.map(function (field) {
        // if formatter is present, use over core's cellTemplate
        if (field.formatter) {
          field.cellTemplate = field.formatter;
        }

        return field;
      }); // add actions column and rows

      if (actions && actions.length) {
        columns.push({
          name: 'actions',
          title: i18n.t('Actions'),
          id: 'actions',
          accessorKey: 'actions'
        });
        data.map(function (row) {
          row.actions = function () {
            return /*#__PURE__*/React.createElement(Actions, {
              actions: actions,
              dropdownActions: dropdownActions,
              keyField: keyField,
              row: row,
              containerRef: _this.dropdownContainerRef
            });
          };
        });
      }

      return columns;
    });

    _this.windowHelper = WindowHelperWrapper(props.windowOverride);
    _this.dropdownContainerRef = /*#__PURE__*/createRef();
    _this.state = {
      isMobile: false
    };
    return _this;
  }

  _inherits(ResponsiveDataList, _React$Component);

  return _createClass(ResponsiveDataList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.destroyWindowWatcher = this.windowHelper.watchBreakpoints(RESPONSIVE_DATA_BREAKPOINT, this.onBreakpointChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyWindowWatcher();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var tableContainerDataProps = this.props.tableContainerDataProps;
      var options = this.props.options || {};

      if (!options.noDataText) {
        options.noDataText = i18n.t('There is no data to display.');
      }

      var _this$props2 = this.props,
          data = _this$props2.data,
          isLoadingData = _this$props2.isLoadingData,
          selectRow = _this$props2.selectRow,
          useCoreTable = _this$props2.useCoreTable,
          pagingInfo = _this$props2.pagingInfo,
          onPageChange = _this$props2.onPageChange,
          totalCount = _this$props2.totalCount;
      return /*#__PURE__*/React.createElement("div", null, this.state.isMobile ? /*#__PURE__*/React.createElement(MobileAccordion, _extends({}, this.props, {
        options: options
      })) : // render foundry table instead when using foundry pagination
      useCoreTable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
        columns: this.setColumns(),
        data: data,
        dataListProps: this.props,
        initialValue: selectRow === null || selectRow === void 0 ? void 0 : selectRow.selected,
        initialSelection: selectRow === null || selectRow === void 0 ? void 0 : selectRow.selected,
        isLoadingData: isLoadingData,
        onPageChange: onPageChange,
        pagingInfo: pagingInfo,
        select: !!selectRow,
        tableOptions: options,
        totalCount: totalCount,
        useCoreHeader: false,
        useCoreTable: useCoreTable
      })) : /*#__PURE__*/React.createElement(Table$1, _extends({}, this.props, {
        tableContainerDataProps: tableContainerDataProps,
        options: options,
        ref: function ref(table) {
          _this2.table = table;
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "dropdown-portal",
        ref: this.dropdownContainerRef
      }));
    }
  }]);
}(React.Component);

_defineProperty(ResponsiveDataList, "propTypes", {
  /* if present passed to actionBar component */
  actionBar: PropTypes.array,
  actions: PropTypes.arrayOf(PropTypes.shape({
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    actionType: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    download: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    icon: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    tooltip: PropTypes.string,
    type: PropTypes.oneOf(['edit', 'delete'])
  })).isRequired,
  isLoadingData: PropTypes.bool,

  /** any table options are passed to MobileAccordion and Table components */
  options: PropTypes.shape({
    /** sets a message to be displayed when the data array is empty */
    noDataText: PropTypes.string
  }),

  /** Data props for the table container */
  tableContainerDataProps: PropTypes.object,
  dropdownActions: PropTypes.bool,
  keyField: PropTypes.string.isRequired,
  selectRow: PropTypes.object,

  /** passed to SelectedItemsRibbon */
  selectedItems: PropTypes.shape({
    count: PropTypes.number
  }),

  /** Data props for react table */
  data: PropTypes.object.isRequired,
  columns: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.shape({
    /** set to true for an action column to add action styles */
    actionColumn: PropTypes.bool,

    /** set to true make the column sortable */
    canSort: PropTypes.bool,

    /** adds additional classes to the rendered cells */
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** don't really need this anymore for this version of BootstrapTable */
    columnOptions: PropTypes.object,

    /** overrides what is rendered as cell content */
    formatter: PropTypes.func,

    /** renders this row attribute as cell text */
    name: PropTypes.string,

    /** defines the column header */
    title: PropTypes.string,

    /** hard code the styled width of a column in either px or % */
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  pageSize: PropTypes.number,
  pagingInfo: PropTypes.object,
  initialValue: PropTypes.string,
  onPageChange: PropTypes.func,
  useCoreHeader: PropTypes.bool,
  useCoreTable: PropTypes.bool,
  totalCount: PropTypes.number,

  /** override the default window object used with WindowHelper */
  windowOverride: PropTypes.object
});

_defineProperty(ResponsiveDataList, "defaultProps", {
  useCoreTable: true
});

ResponsiveDataList.displayName = "ResponsiveDataList";
export { ResponsiveDataList };